import { ApiResponse } from "../schemas/apiResponseSchema";
import apiClient from "../clients/apiClient";
import { Schemas } from "../types/api-types";

type CashBook = Schemas['CashBookResponse']

export async function getCashBooks(): Promise<CashBook[]> {
    try {
        const response: ApiResponse<CashBook[]> = (await apiClient.get('/cashier/cash_books')).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Cashier sign-in failed');
        }
        throw new Error('network error, please contact support team');
    }

}